import React from 'react'
import './bannerKnowMore.scss'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import { LOCALE } from '../../../constants/activity-constants'

const BannerKnowMore = () => {
  const {
    BannerKnowMoreDesk: { childImageSharp: BannerKnowMoreDesk },
    BannerKnowMoreMob: { childImageSharp: BannerKnowMoreMob },
    BannerKnowMoreDeskCL: { childImageSharp: BannerKnowMoreDeskCL },
    BannerKnowMoreMobCL: { childImageSharp: BannerKnowMoreMobCL },
  } = useStaticQuery(graphql`
    {
      BannerKnowMoreDesk: file(name: { eq: "banner-know-more-desk" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      BannerKnowMoreMob: file(name: { eq: "banner-know-more-mob" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      BannerKnowMoreDeskCL: file(name: { eq: "banner-know-more-desk-CL" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      BannerKnowMoreMobCL: file(name: { eq: "banner-know-more-mob-CL" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const bannersbyLocale = {
    'es-CO': [BannerKnowMoreMob, BannerKnowMoreDesk],
    'es-CL': [BannerKnowMoreMobCL, BannerKnowMoreDeskCL],
  }

  const banners = bannersbyLocale[LOCALE] || bannersbyLocale['es-CO']


  return (
    <div className="f-banner-know-more">
      <div
        className="f-banner-know-more__container"
        onClick={() => {
          pushEventDataLayer({
            event: 'Interacciones - Banners',
            category: 'banners',
            action: 'click',
            label: 'APRENDE MÁS ',
            banner_name: `Conoce toda sobre la Tecnología de Cur-V y aumenta tus posibilidades de ganar los retos`,
            location: 'nosotras.com/embajadoras',
          })
          navigate('/ser-embajadora')
        }}
      >
        <GatsbyImage
          objectFit="cover"
          image={withArtDirection(getImage(banners[1]), [
            {
              media: '(max-width: 1024px)',
              image: getImage(banners[0]),
            },
            ]
          )}
          alt="Aprende Más"
          className="f-banner-know-more__image"
        />
      </div>
    </div>
  )
}

export default BannerKnowMore
